import Button from "@material-ui/core/esm/Button";
import React from 'react';
import { NavLink } from 'react-router-dom';
import useStyles from './ButtonStyles';
export default function NavLinkButton({
  path,
  className,
  label,
  icon
}) {
  const {
    navLinkLabel
  } = useStyles();
  return /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "text",
    classes: {
      root: navLinkLabel
    },
    component: NavLink,
    to: path,
    className: className
  }, icon, label);
}
NavLinkButton.defaultProps = {
  className: '',
  icon: undefined
};